import {NgModule} from '@angular/core';
import {FloatMarkupDirective} from './float-markup.directive';

@NgModule({
    declarations: [
        FloatMarkupDirective
    ],
    exports: [
        FloatMarkupDirective
    ]
})
export class FloatMarkupModule {}
